module.exports = __webpack_public_path__ + "dfb5567a5341d869418eadef3cc340b1.pdf";